import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import Home from '../pages/homePage/HomePage';
import Collection from '../pages/collection/Collection';
import Explore from '../pages/explore/Explore';
import TradeChart from '../pages/tradeChart/TradeChart';
import ItemDetails from '../pages/itemDetails/ItemDetails';
import MainLayout from '../layouts/MainLayout.jsx';
import Auth from '../pages/auth/Auth';
import AddNft from '../pages/addNft/AddNft';
import Profile from '../pages/profile/Profile';

const routes = (
    <Route path="/" element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/item-details/:nftAddress/:nftId" element={<ItemDetails />} />
        {/* <Route path="/collection" element={<Collection />} /> */}
        <Route path="/trade-chart" element={<TradeChart />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/add-nft" element={<AddNft />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/*" element={<h1>404</h1>} />
    </Route>
);

export const router = createBrowserRouter(createRoutesFromElements(routes));
